import React, { useState, useEffect } from "react";
import { Loader, Input, Icon } from "semantic-ui-react";
import { filter } from "lodash";
import {
  HeaderPage,
  TableProductAdmin,
  AddEditProductForm,
} from "../../components/Admin";
import { ModalBasic, ModalConfirm } from "../../components/Common";
import { useProduct } from "../../hooks";

export function ProductAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [search, setSearch] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const { loading, products, getProducts, deleteProduct } = useProduct();

  useEffect(() => {
    getProducts();
  }, [refetch]);

  const openCloseModal = () => setShowModal((prev) => !prev);
  const onRefetch = () => setRefetch((prev) => !prev);

  const addProduct = () => {
    setTitleModal("Nuevo producto");
    setContentModal(
      <AddEditProductForm onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updateProduct = (data) => {
    setTitleModal("Actualizar producto");
    setContentModal(
      <AddEditProductForm
        onClose={openCloseModal}
        onRefetch={onRefetch}
        product={data}
      />
    );
    openCloseModal();
  };

  const onDeleteProduct = (data) => setDeleteTarget(data);

  const confirmDeleteProduct = async () => {
    await deleteProduct(deleteTarget.id);
    setDeleteTarget(null);
    onRefetch();
  };

  const searchTerm = search.trim().toLowerCase();
  const filteredProducts = searchTerm
    ? filter(
        products,
        (product) =>
          product.title.toLowerCase().includes(searchTerm) ||
          product.category_data?.title.toLowerCase().includes(searchTerm)
      )
    : products;

  return (
    <>
      <HeaderPage
        title="Productos"
        btnTitle="Nuevo producto"
        btnClick={addProduct}
      />

      <Input
        fluid
        icon={
          search ? (
            <Icon name="close" link onClick={() => setSearch("")} />
          ) : (
            <Icon name="search" />
          )
        }
        placeholder="Buscar por producto o categoria..."
        value={search}
        onChange={(_, data) => setSearch(data.value)}
        style={{ margin: "10px 0" }}
      />

      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <TableProductAdmin
          products={filteredProducts}
          updateProduct={updateProduct}
          deleteProduct={onDeleteProduct}
        />
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

      <ModalConfirm
        title="¿Eliminar producto?"
        content={`Se eliminará "${deleteTarget?.title}" de forma permanente.`}
        show={!!deleteTarget}
        onCloseText="Cancelar"
        onClose={() => setDeleteTarget(null)}
        onConfirmText="Eliminar"
        onConfirm={confirmDeleteProduct}
      />
    </>
  );
}
